<template>
    <v-tooltip v-if="visible" bottom max-width="240">
        <template #activator="{ on, attrs }">
            <v-chip x-small outlined color="accent" class="ai-beta-chip" v-bind="attrs" v-on="on">
                {{ $t('ai.beta_label') }}
            </v-chip>
        </template>
        <span>{{ $t('ai.beta_tooltip') }}</span>
    </v-tooltip>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'AiBetaChip',
    computed: {
        ...mapState(['config']),
        visible(vm = this) {
            return vm.config?.aiBeta !== false
        },
    },
}
</script>

<style scoped>
.ai-beta-chip {
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}
</style>
